export const FETCH_COMPANY_REQUESTED = 'FETCH_COMPANY_REQUESTED';
export const FETCH_COMPANY_SUCCEEDED = 'FETCH_COMPANY_SUCCEEDED';
export const FETCH_COMPANY_FAILED = 'FETCH_COMPANY_FAILED';

export const UPDATE_COMPANY_REQUESTED = 'UPDATE_COMPANY_REQUESTED';
export const UPDATE_COMPANY_SUCCEEDED = 'UPDATE_COMPANY_SUCCEEDED';
export const UPDATE_COMPANY_FAILED = 'UPDATE_COMPANY_FAILED';

export const FETCH_MEMBERS_REQUESTED = 'FETCH_MEMBERS_REQUESTED';
export const FETCH_MEMBERS_SUCCEEDED = 'FETCH_MEMBERS_SUCCEEDED';
export const FETCH_MEMBERS_FAILED = 'FETCH_MEMBERS_FAILED';

export const UPDATE_MEMBER_REQUESTED = 'UPDATE_MEMBER_REQUESTED';
export const UPDATE_MEMBER_SUCCEEDED = 'UPDATE_MEMBER_SUCCEEDED';
export const UPDATE_MEMBER_FAILED = 'UPDATE_MEMBER_FAILED';

export const REMOVE_MEMBERS_REQUESTED = 'REMOVE_MEMBERS_REQUESTED';
export const REMOVE_MEMBERS_SUCCEEDED = 'REMOVE_MEMBERS_SUCCEEDED';
export const REMOVE_MEMBERS_FAILED = 'REMOVE_MEMBERS_FAILED';

export const ADD_CLIENT = 'ADD_CLIENT';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const UPDATE_MEMBER_LIST = 'UPDATE_MEMBER_LIST';



// WEBPACK FOOTER //
// ./src/services/company/actionTypes.js